import React from "react";
import { SwapOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./draggable-handle.module.css";
const { button: buttonClassName } = styles;

export const DraggableHandle: React.FC = (props) => (
  <Button icon={<SwapOutlined />} {...props} className={buttonClassName} shape="circle" />
);
